<template>
  <svg class="text-error" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path d="M22,15a7,7,0,1,1-7-7A7,7,0,0,1,22,15Zm-7,1.411a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,15,16.411Zm-1.233-4.667.209,3.839a.339.339,0,0,0,.338.32h1.37a.339.339,0,0,0,.338-.32l.209-3.839a.339.339,0,0,0-.338-.357H14.105a.339.339,0,0,0-.338.357Z" transform="translate(-8 -8)" class="fill-current"/>
  </svg> 
</template>
